export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function formatRelative(dateStr: string): string {
  const target = new Date(`${dateStr}T00:00:00`).getTime();
  const now = new Date('2026-09-10T00:00:00').getTime();
  const days = Math.round((now - target) / 86400000);
  if (days <= 0) return '今天';
  if (days === 1) return '昨天';
  if (days < 7) return `${days} 天前`;
  return dateStr;
}